/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import Line from "components/Placeholders/Line";
import { selectors as JobDetailSelectors } from "store/modules/jobDetails";
import DisableCellOverlay from "../../components/Controls/DisableCellOverlay";
import ConfirmMenu from "../../components/Menus/ConfirmMenu";
import Can from "components/Authorization/Can";
import { PositionPermissions } from "helpers/constants/permissions";

export default function useConfirmed(disabled) {
    const canAddWorker = useSelector(JobDetailSelectors.getCanAddWorker);
    return {
        id: "confirmed",
        width: 60,
        Header: () => (
            <Tooltip title="Confirmed" placement="top">
                <span>C.</span>
            </Tooltip>
        ),
        Cell: ({ row: { original: { workerId, isConfirmed, confirmedAt } } }) => {
            return (
                <>
                    <ConfirmMenu workerId={workerId} isConfirmed={isConfirmed} confirmedAt={confirmedAt} />
                    <DisableCellOverlay visible={disabled} />
                </>
            );
        },
        Footer: (<Can perform={PositionPermissions.create.fill.value}>
            {allowed => {
                if (!allowed) {
                    return null;
                }
                return canAddWorker && !disabled ? <Line /> : null
            }}
        </Can>)
    };
}
